<template>
  <header class="heading">
    <div class="heading__meta" data-reveal>
      <span class="heading__index">({{ index }})</span>
      <span class="heading__presents">
        <img src="@/assets/logotipo-short.webp" alt="Coppados">
        <span>presents</span>
      </span>
    </div>
    <h2 class="display heading__title" data-reveal="chars">{{ title }}</h2>
    <div v-if="$slots.default" class="heading__aside" data-reveal>
      <slot />
    </div>
    <div class="heading__line" data-reveal="line"></div>
  </header>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: {
    index: { type: String, required: true },
    title: { type: String, required: true }
  }
}
</script>

<style scoped>
.heading {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  gap: 1.5rem 2rem;
  padding: 0 var(--gutter);
}

.heading__meta {
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--fs-small);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--c-muted);
}

.heading__presents {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.heading__presents img {
  height: 0.95rem;
  width: auto;
}

.heading__title {
  margin-left: -0.04em;
}

.heading__aside {
  max-width: 30ch;
  padding-bottom: 0.6em;
  color: var(--c-muted);
  font-size: var(--fs-body);
  line-height: 1.4;
}

.heading__line {
  grid-column: 1 / -1;
  height: 1px;
  background: var(--c-line);
}

@media (max-width: 760px) {
  .heading {
    grid-template-columns: 1fr;
  }

  .heading__aside {
    padding-bottom: 0;
  }
}
</style>
